/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetWorkspaceUserPermissionsResponse } from '../../models/get-workspace-user-permissions-response';

export interface GetWorkspaceUserPermissions$Params {

/**
 * Workspace ID
 */
  workspaceId: number;

/**
 * User ID
 */
  userId: string;
}

export function getWorkspaceUserPermissions(http: HttpClient, rootUrl: string, params: GetWorkspaceUserPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetWorkspaceUserPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getWorkspaceUserPermissions.PATH, 'get');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetWorkspaceUserPermissionsResponse>;
    })
  );
}

getWorkspaceUserPermissions.PATH = '/workspaces/{workspaceId}/user/{userId}/permissions';
